export default "__VITE_ASSET__JZOuj6j$__"